module.exports = __webpack_public_path__ + "img/xeno-4.d3007139.jpg";